/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  FeeService,
  type Wealthlane_AwardService_Dtos_Fee_CreateSecFeeDto,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';

function toSecFeeRate(rate: unknown): number | undefined {
  if (rate == null || rate === '') return undefined;
  if (typeof rate === 'number') return rate;
  const parsed = Number(String(rate).replaceAll(',', ''));
  return Number.isNaN(parsed) ? undefined : parsed;
}

function toCreateSecFeeBody(payload: unknown): Array<Wealthlane_AwardService_Dtos_Fee_CreateSecFeeDto> {
  const items = Array.isArray(payload) ? payload : [payload];
  return items.map((item: Record<string, unknown>) => ({
    effectiveDate: item.effectiveDate as string | undefined,
    rate: toSecFeeRate(item.rate),
  }));
}

const usePostSecFee = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        FeeService.postApiAwardApiAppFeeSecFee(toCreateSecFeeBody(payload))
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label={'Success'} message={'SEC Fee Added'} />);
          queryClient.invalidateQueries('getSecFeeList');
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSecFee;
